import React, { useState, useEffect } from "react";
import { db } from "../../../../assets/firebase/firebaseconfig";
import { ref, get, remove, onValue } from "firebase/database";

const ContactManager = () => {
  const [contacts, setContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("desc"); // Mới nhất lên đầu

  // 1. Lấy dữ liệu từ nhánh 'contacts'
  useEffect(() => {
    const contactRef = ref(db, "contacts");
    onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setContacts(list);
      } else {
        setContacts([]);
      }
    });
  }, []);

  // 2. Hàm Xóa yêu cầu liên hệ
  const handleDelete = async (id) => {
    if (window.confirm("Bạn có chắc chắn muốn xóa yêu cầu liên hệ này?")) {
      try {
        await remove(ref(db, `contacts/${id}`));
        alert("Đã xóa liên hệ!");
      } catch (error) {
        console.error(error);
      }
    }
  };

  // 3. Logic Tìm kiếm & Sắp xếp (Tìm theo tên hoặc số điện thoại)
  const filteredContacts = contacts
    .filter(
      (c) =>
        (c.username?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
        (c.phone || "").includes(searchTerm)
    )
    .sort((a, b) => {
      return sortOrder === "desc"
        ? b.createdAt - a.createdAt
        : a.createdAt - b.createdAt;
    });

  return (
    <div className="admin-content-inner">
      <div className="page-header">
        <h1>LIÊN HỆ TỪ KHÁCH HÀNG</h1>
      </div>

      {}
      <div className="filter-section card">
        <div className="filter-bar-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Tìm theo tên khách hàng hoặc số điện thoại..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="sort-box">
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="sort-select"
            >
              <option value="desc">Yêu cầu mới nhất</option>
              <option value="asc">Yêu cầu cũ nhất</option>
            </select>
          </div>

          {}
        </div>
      </div>

      {}
      <div className="table-section card">
        <div className="table-header">
          <h3>Danh sách yêu cầu ({contacts.length})</h3>
        </div>

        <table className="main-table">
          <thead>
            <tr>
              <th>USERNAME</th>
              <th>SỐ ĐIỆN THOẠI</th>
              <th>EMAIL</th>
              <th>DỊCH VỤ</th>
              <th>YÊU CẦU</th>
              <th>NGÀY GỬI</th>
              <th>THAO TÁC</th>
            </tr>
          </thead>
          <tbody>
            {filteredContacts.length > 0 ? (
              filteredContacts.map((item) => (
                <tr key={item.id}>
                  <td>
                    <strong>{item.username}</strong>
                  </td>
                  <td>
                    <span className="sub-tag">{item.phone}</span>
                  </td>
                  <td>{item.email}</td>
                  <td>
                    <span className="service-text">{item.service}</span>
                  </td>
                  <td>
                    <div className="table-desc-short" title={item.request}>
                      {item.request}
                    </div>
                  </td>
                  <td>
                    <div className="time-display">
                      {item.createdAt
                        ? new Date(item.createdAt).toLocaleString("vi-VN", {
                            hour: "2-digit",
                            minute: "2-digit",
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })
                        : "Không rõ"}
                    </div>
                  </td>
                  <td>
                    <div className="action-btns">
                      <button
                        className="btn-delete-tool"
                        onClick={() => handleDelete(item.id)}
                      >
                        Xóa
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  Chưa có liên hệ nào.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactManager;
